import { Component, signal, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IdleTimeoutService } from './core/services/idle-timeout.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('cubus-verde');
  private readonly idleTimeoutService = inject(IdleTimeoutService);

  ngOnInit(): void {
    this.idleTimeoutService.startWatching();
  }
}
